/**
* jv.candidate.details.task.controller Module
*
* Description
*/
angular.module('jv.candidate.details.task.controller', [])
    .run(function($window){
        $window.adjustTasksHeight = function( height ){
            $('#jv-tasksIframe').css({
                'height': height+'px'
            });
            var titleElement = $('#jv-tasksIframe').contents().find( '#jv-tasks .jv-pageTitle' );
            $(titleElement).css({
                'padding': '10px 0px'
            });
        };
    })
    .controller('jvCandDetailsTaskController', ['$scope','$routeParams',
        function($scope, $routeParams){
            $scope.tasksIframeSrc = window.jvUrls.source + '/task/list.html?noHeader=true&entityType=Application&entityIds='+$routeParams.applicationId;
            $scope.flags.loading = false;
        }
    ]);